import { CAlert } from './CAlert.js';
import { CAlertHeading } from './CAlertHeading.js';
import { CAlertLink } from './CAlertLink.js';

const CAlertPlugin = {
    install: (app) => {
        app.component(CAlert.name, CAlert);
        app.component(CAlertHeading.name, CAlertHeading);
        app.component(CAlertLink.name, CAlertLink);
    },
};

export { CAlert, CAlertHeading, CAlertLink, CAlertPlugin };
//# sourceMappingURL=index.js.map
